export default "__VITE_ASSET__fzCcl4Zq__"